import { render, staticRenderFns } from "./charge_project_page.vue?vue&type=template&id=5f878be2&scoped=true"
import script from "./charge_project_page.vue?vue&type=script&lang=js"
export * from "./charge_project_page.vue?vue&type=script&lang=js"
import style0 from "./charge_project_page.vue?vue&type=style&index=0&id=5f878be2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f878be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f878be2')) {
      api.createRecord('5f878be2', component.options)
    } else {
      api.reload('5f878be2', component.options)
    }
    module.hot.accept("./charge_project_page.vue?vue&type=template&id=5f878be2&scoped=true", function () {
      api.rerender('5f878be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/charge_project_page.vue"
export default component.exports